import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';

import router from '@/router';

if (process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID?.trim()) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
    compatibility: true,
    vueRouter: router,
  });
}
